<template>
  <a-form :form="form" @submit="handleSubmit" style="width: 96%;margin: 0 auto">
    <a-form-item v-if="this.type === '2'">
      <span class="spanOne">{{ $tc('lang.payType.System_Order_Nr') }}：</span>
      <span>{{ this.type === '1' ? data.setmealId : data.orderId }}</span>
    </a-form-item>
    <a-form-item>
      <span class="spanOne">
        {{
          this.type === '1'
            ? $tc('lang.payType.Package')
            : $tc('lang.payType.Order_Type')
        }}:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
      <span class="spanTow">{{
        type === '1' ? data.setmealName : orderType
      }}</span>
    </a-form-item>
    <a-form-item>
      <span class="spanOne"
        >{{ $tc('lang.payType.Amount') }}：&nbsp;&nbsp;&nbsp;&nbsp;</span
      >
      <span class="spanThree"
        >¥{{
          this.type === '1'
            ? data.setmealDiscountrmb
            : data.orderServicechargermb === null
            ? 0
            : data.orderServicechargermb
        }}</span
      >
    </a-form-item>

    <!-- 代金券 -->
    <a-form-item v-if="this.type == '2' && value != 3">
      <span class="spanOne"
        >{{ $tc('lang.payType.Coupon') }}：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span
      >
      <div
        class="daijinquan"
        v-if="couponData.unused && couponData.unused.length > 0"
      >
        <div v-for="item in couponData.unused" :key="item.id">
          <div
            class="daijinquan-item"
            v-if="item.couponUnit == 1"
            @click="checkDai(item)"
            :class="[
              { checked: checkedDai.id == item.id },
              { usdBackground: !Chinese },
            ]"
          >
            <div class="mony">￥{{ item.couponLimit }}</div>
            <div class="jieshao">
              <p>
                {{ $tc('lang.payType.Valid_Till') }}:
                {{ $momentData(item.couponEnddate) }}
              </p>
            </div>
            <div class="right-bottom">
              <img src="../image/yes.png" />
            </div>
          </div>
        </div>
      </div>
      <div v-else style="display: inline-block">
        {{ $tc('lang.payType.Not_Available') }}
      </div>
    </a-form-item>

    <!-- 实际支付金额 -->
    <a-form-item>
      <span class="spanOne"
        >{{ $tc('lang.payType.Final_Payment') }}：&nbsp;&nbsp;&nbsp;&nbsp;</span
      >
      <span class="spanThree">¥{{ infactMonyDai }}</span>
    </a-form-item>

    <a-form-item>
      <span class="spanOne"
        >{{ $tc('lang.payType.Payment') }}: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span
      >
      <a-radio-group @change="onChange" v-model="value">
        <a-radio :value="1">
          <img class="imgePay" src="../../../views/pay/image/weixin.jpg" />
          <span class="spamFour"
            >{{ $tc('lang.payType.Wechat_Pay') }}<br />{{
              $tc('lang.payType.with_no_extra_cost')
            }}</span
          >
        </a-radio>
        <a-radio :value="2"
          ><img class="imgePay" src="../../../views/pay/image/zhifibao.jpg" />
          <div class="spamFour">
            {{ $tc('lang.payType.Alipay') }}<br />{{
              $tc('lang.payType.with_no_extra_cost')
            }}
          </div>
        </a-radio>
        <a-radio v-if="type != 1" :value="3"
          ><img class="imgePay" src="../../../views/pay/image/xianxia.jpg" />
          <span class="spamFour"
            >{{ $tc('lang.payType.Bank_Transfer') }}<br />{{
              $tc('lang.payType.Photo_Bank_required')
            }}</span
          >
        </a-radio>
      </a-radio-group>
    </a-form-item>
    <a-form-item style="text-align: center">
      <a-button class="payButton" @click="action()" :disabled="disabled">{{
        $tc('lang.payType.Submit')
      }}</a-button>
    </a-form-item>
    <pay-module ref="payModule"></pay-module>
  </a-form>
</template>

<script>
import payModule from '../components/payModule';
export default {
  name: 'renmPay',
  data() {
    return {
      // 1-微信，2-支付宝，3-线下
      value: 1,
      disabled: false,
      form: this.$form.createForm(this),
      data: {},
      // 1-套餐，2-订单
      type: '1',
      orderType: '',
      htmls: '',
      user: {},
      Chinese: '',
      checkedDai: {},
      couponData: [], //代金券数据
      infactMonyDai: 0,
    };
  },
  components: {
    'pay-module': payModule,
  },
  created() {
    //代金券数据
    // this.$store.dispatch('expired/getCoupon');

    this.queryOederById();
    // 获取用户sessionStorage信息
    if (sessionStorage.getItem('user') !== null) {
      this.user = JSON.parse(sessionStorage.getItem('user')) || {};
    }
    //判断当前语言环境
    if (this.$i18n.locale === 'zh-CN') {
      this.Chinese = true;
    } else if (this.$i18n.locale === 'en-US') {
      this.Chinese = false;
    }
  },
  computed: {
    language() {
      return this.$i18n.locale;
    },
    // 全部优惠卷数据
    // couponData: {
    //   get() {
    //     return this.$store.state.expired.couponData;
    //   },
    //   set(value) {
    //     this.$store.commit('expired/save', {
    //       couponData: value,
    //     });
    //   },
    // },
  },
  watch: {
    language() {
      if (this.language === 'zh-CN') {
        this.Chinese = true;
      } else if (this.language === 'en-US') {
        this.Chinese = false;
      }
    },
  },
  methods: {
    /**
     * 获取代金券信息
     */
    async getCoupon() {
      // 获取用户session信息
      // const user = JSON.parse(sessionStorage.getItem('user')) || {};
      const orderId = this.data.orderId;
      const resData = await this.$http.post('/hzwmj/person-coupon/getCoupon', {
        personId: this.user.id,
      });
      if (resData.code === 200) {
        this.couponData = resData.data;
        if (this.couponData.unused && this.couponData.unused.length > 0) {
          this.couponData.unused = this.couponData.unused.filter(item => {
            // console.log(item);
            if (
              item.couponIschoose == '2' &&
              item.orderId == orderId &&
              item.couponUnit == 1
            ) {
              this.checkDai(item);
              return true;
            } else if (item.couponIschoose == '1' && item.couponUnit == 1) {
              return true;
            } else {
              return false;
            }
          });
        }
      } else if (resData.code === 900) {
        this.$message.error(resData.msg);
      } else {
        this.$message.error('系统异常');
      }
    },
    //选择代金券
    checkDai(value) {
      if (this.checkedDai.id && value.id == this.checkedDai.id) {
        //修改代金券状态
        if (this.checkedDai.id) {
          this.$http.post('/hzwmj/person-coupon/updateCoupon', {
            id: this.checkedDai.id,
            couponState: '1',
            couponIschoose: '1',
            orderId: '',
          });
        }
        this.checkedDai = {};
      } else {
        this.checkedDai = value;
      }
      this.infactMony();
    },
    //计算实际金额
    infactMony() {
      let money = 0;
      if (this.type == 1) {
        money = this.data.setmealDiscountrmb || 0;
      } else {
        money = this.data.orderServicechargermb || 0;
      }
      if (this.checkedDai.couponLimit && this.value != 3) {
        this.infactMonyDai =
          Math.round(
            (Number(money) - Number(this.checkedDai.couponLimit)) * 100,
          ) / 100;
      } else {
        this.infactMonyDai = money;
      }
    },
    //数据提交
    handleSubmit() {
      // console.log(e);
      event.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log('=====数据====', values);
        }
      });
    },
    // 支付币别区分
    onChange(e) {
      // if (e.target.value == 3) {
      this.infactMony();
      // }
      this.value = e.target.value;
      console.log('radio checked', e.target.value);
    },
    // 查询数据
    queryOederById() {
      const url = window.location.href;
      const theRequest = new Object();
      // 取是否以问号(?)为下标如果有者返回该值的下标，如果没有就返回-1
      if (url.indexOf('?') != -1) {
        //截取字符串 以问号(?)开始在进行加1前进一个的下标，以那个下标为准开始截取
        const str = url.substr(url.indexOf('?') + 1);
        const strs = str.split('&');
        for (let i = 0; i < strs.length; i++) {
          theRequest[strs[i].split('=')[0]] = strs[i].split('=')[1];
        }
        // return theRequest;
      }
      console.log('====theRequest===', theRequest);
      this.type = theRequest.type;
      if (theRequest.type === '1') {
        this.$nextTick(() => {
          this.$http
            .get('/hzwmj/setmeal/detail', {
              params: {
                id: theRequest.id,
                personId:this.user.id
              },
            })
            .then(data => {
              if (data.code === 200) {
                const buyData = data.data;
                this.data = buyData;
                console.log('=====buyData=====', buyData);
                buyData.setmealDiscountrmb === null ||
                buyData.setmealDiscountrmb === '0'
                  ? this.disabled === true
                  : this.disabled === false;
                this.infactMony();
              } else if (data.code === 900) {
                this.$message.error(data.msg);
              } else {
                this.$message.error('系统异常');
              }
            })
            .catch(() => {});
        });
      }
      if (theRequest.type === '2') {
        this.$nextTick(() => {
          this.$http
            .get('/hzwmj/workorder/getOrderBasic', {
              params: {
                id: theRequest.id,
              },
            })
            .then(data => {
              if (data.code === 200) {
                const buyData = data.data;
                this.data = buyData;
                buyData.orderServicechargermb === null ||
                buyData.orderServicechargermb === '0'
                  ? this.disabled === true
                  : this.disabled === false;
                // 1（中期验货）、2（尾期验货）、3（面料验货）、4（质量验厂）、5（监装）
                this.orderType = this.getOrderType(buyData.orderType);
                console.log('=====buyData=====', buyData);
                this.getCoupon();
                this.infactMony();
              } else if (data.code === 900) {
                this.$message.error(data.msg);
              } else {
                this.$message.error('系统异常');
              }
            })
            .catch(() => {});
        });
      }
    },
    // 判定余额够支付的话可以进行支付下单
    toggleDisabled() {
      this.disabled = !this.disabled;
    },
    // 立即付款
    action() {
      this.$nextTick(() => {
        this.$refs.payModule.init();
        console.log('this.data', this.data.orderId);
        // 微信支付
        if (this.value === 1) {
          //修改代金券状态
          if (this.checkedDai.id) {
            this.$http.post('/hzwmj/person-coupon/updateCoupon', {
              // params: {
              id: this.checkedDai.id,
              couponState: '1',
              couponIschoose: '2',
              orderId: this.type === '1' ? this.data.id : this.data.orderId,
              // },
            });
          }
          // 打开新窗口
          const tempwindow = window.open('about:blank');
          // 微信
          this.$http
            .get('/hzwmj/wxpay/outTradeNo')
            .then(data => {
              if (data.code === 200) {
                const buyData = data.data;
                console.log('==buyDatass====', buyData);
                const { href } = this.$router.resolve({
                  path: '/wechpayment',
                  query: {
                    type: this.type,
                    // mb:
                    //   this.type === '1'
                    //     ? this.data.setmealDiscountrmb
                    //     : this.data.orderServicechargermb,
                    mb: this.infactMonyDai,
                    outTradeNo: buyData,
                    orderId:
                      this.type === '1' ? this.data.id : this.data.orderId,
                    personId: this.user.id,
                    checkedDaiId: this.checkedDai.id,
                  },
                });
                // let aLink = document.createElement('a');
                // document.body.appendChild(aLink);
                // aLink.target = '_blank';
                // aLink.href = href;
                // aLink.click();
                // aLink.remove();
                // 重定向url到项目中的空页面
                tempwindow.location = href;
              } else if (data.code === 900) {
                this.$message.error(data.msg);
              } else {
                this.$message.error('系统异常');
              }
            })
            .catch(() => {});
        }
        // 支付宝支付
        if (this.value === 2) {
          // 打开新窗口
          const tempwindow = window.open('about:blank');
          // 支付宝
          this.$http
            .post('/hzwmj/ALYPay/getPagePay', {
              // outTradeNo: '90909623261236223',
              outTradeNo:
                this.type === '1' ? this.data.setmealId : this.data.orderId,
              totalAmount: this.infactMonyDai,
              // totalAmount:
              //   this.type === '1'
              //     ? this.data.setmealDiscountrmb
              //     : this.data.orderServicechargermb,
              // 付款成功以后回调跳转的地址
              payUrlName:
                this.type === '1'
                  ? 'http://www.minderworks.com/mySetMeal'
                  : 'http://www.minderworks.com/allorder',
              subject:
                this.type === '1' ? this.data.setmealName : this.orderType,
              // 1-套餐，2-订单
              payOrderType: this.type === '1' ? '1' : '2',
              // 人员id
              personId: this.user.id,
              couponId: this.checkedDai.id || '',
            })
            .then(data => {
              if (data.code === 200) {
                const buyData = data.data;
                console.log('==buyDatass====', buyData);

                //返回参数
                const { href } = this.$router.resolve({
                  path: '/AlipayPayment',
                  query: { htmls: buyData },
                });
                this.htmls = buyData;
                // let aLink = document.createElement('a');
                // document.body.appendChild(aLink);
                // aLink.target = '_blank';
                // aLink.href = href;
                // aLink.click();
                // aLink.remove();
                //打开新页面
                tempwindow.location = href;
              } else if (data.code === 900) {
                this.$message.error(data.msg);
              } else {
                this.$message.error('系统异常');
              }
            })
            .catch(() => {});
        }
        // 线下支付
        if (this.value === 3) {
          const tempwindow = window.open('about:blank');
          // 线下支付
          console.log('sss:', this.data);
          const { href } = this.$router.resolve({
            path: '/underpayment',
            query: {
              id: this.data.id,
              // 1-套餐，2-订单
              type: this.type,
              // 1-人民币, 美元2
              moneyType: 1,
            },
          });
          // let aLink = document.createElement('a');
          // document.body.appendChild(aLink);
          // aLink.target = '_blank';
          // aLink.href = href;
          // aLink.click();
          // aLink.remove();

          // window.open(href, '_blank');
          tempwindow.location = href;
        }
      });
    },
    //设置订单类型
    getOrderType(res) {
      if (this.Chinese == true) {
        switch (res) {
          case '1':
            return '中期验货';
          case '2':
            return '尾期验货';
          case '3':
            return '面料验货';
          case '4':
            return '质量验厂';
          case '5':
            return '监装';
        }
      } else {
        switch (res) {
          case '1':
            return 'Mid Term Inspection';
          case '2':
            return 'Final Inspection';
          case '3':
            return 'Fabric Inspection';
          case '4':
            return 'Factory Assessment';
          case '5':
            return 'Loading Supervision';
        }
      }
    },
  },
};
</script>

<style scoped lang="less">
/*中间的过度的横线*/
.link-top {
  width: 100%;
  height: 1px;
  border-top: solid #acc0d8 1px;
}
.spanOne {
  line-height: 25px;
  font-size: 16px;
  color: #50688c;
}
.spanTow {
  font-weight: 800;
  font-size: 20px;
}
.spanThree {
  height: 64px;
  line-height: 64px;
  font-size: 24px;
  color: #158be4;
  font-weight: 600;
}
.spamFour {
  color: #8492a6;
  display: inline-block;
  vertical-align: middle;
}
.imgePay {
  width: 50px;
  display: inline-block;
}
.payButton {
  background: #ff8d1a;
  border: 1px solid #ff8d1a;
  color: rgb(255, 255, 255);
  width: 250px;
  height: 40px;
}
.daijinquan {
  // display: inline-block;
  // vertical-align: top;
  margin-left: 90px;
  > div {
    display: inline-block;
  }
  .daijinquan-item {
    width: 260px;
    height: 88px;
    background-image: url(../image/daijin.png);
    background-repeat: no-repeat;
    background-size: 100%;
    overflow: hidden;
    position: relative;
    display: inline-block;
    margin-right: 10px;
    .mony {
      color: #fff;
      font-size: 30px;
      margin-left: 110px;
      margin-top: 22px;
    }
    .jieshao {
      text-align: right;
      bottom: 5px;
      right: 5px;
      position: absolute;
      p {
        color: #0da3d6;
        margin-bottom: 0;
        font-size: 12px;
        line-height: 16px;
      }
    }
  }
  .usdBackground {
    background-image: url(../image/daijin2.png);
  }
  .right-bottom {
    display: none;
    width: 40px;
    height: 40px;
    position: absolute;
    bottom: -1px;
    right: -1px;
    img {
      width: 100%;
    }
  }
  .checked {
    border: 2px solid #d49c4a;
    .right-bottom {
      display: block;
    }
  }
}
</style>
